document.addEventListener('DOMContentLoaded',()=>{const drawer=document.querySelector('[data-ezv3-menu]');const open=document.querySelector('[data-ezv3-menu-open]');const closes=document.querySelectorAll('[data-ezv3-menu-close]');const close=()=>{drawer?.classList.remove('is-open');drawer?.setAttribute('aria-hidden','true');document.body.style.overflow=''};open?.addEventListener('click',()=>{drawer?.classList.add('is-open');drawer?.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'});closes.forEach(x=>x.addEventListener('click',close));document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});document.querySelectorAll('.ezv3-navitem').forEach(item=>item.addEventListener('toggle',()=>{if(item.open)document.querySelectorAll('.ezv3-navitem[open]').forEach(other=>{if(other!==item)other.removeAttribute('open')})}));document.addEventListener('click',e=>{if(!e.target.closest('.ezv3-navitem'))document.querySelectorAll('.ezv3-navitem[open]').forEach(x=>x.removeAttribute('open'))})});

document.addEventListener('click', (event) => {
  const accountLink = event.target.closest('[data-account-link]');
  if (!accountLink) return;
  const href = accountLink.getAttribute('href');
  if (!href || href === '#') return;
  event.preventDefault();
  window.location.assign(href);
});


/* hover-open */
document.addEventListener('DOMContentLoaded',()=>{
  if(window.innerWidth<990) return;
  const items=[...document.querySelectorAll('.ezv3-navitem')];
  items.forEach(item=>{
    let t;
    const open=()=>{
      clearTimeout(t);
      items.forEach(i=>{if(i!==item)i.removeAttribute('open');});
      item.setAttribute('open','');
    };
    const close=()=>{
      clearTimeout(t);
      t=setTimeout(()=>{
        if(!item.matches(':hover')&&!item.matches(':focus-within')){
          item.removeAttribute('open');
        }
      },180);
    };
    item.addEventListener('mouseenter',open);
    item.addEventListener('mouseleave',close);
    item.addEventListener('focusin',open);
    item.addEventListener('focusout',close);
  });
});


/* =========================================================
   EzStudio OS v1.0.5 — RESPONSIVE HEADER V3
   ========================================================= */
(() => {
  const initialiseResponsiveHeader = () => {
    const nav = document.querySelector('[data-ezv3-responsive-nav]');
    const more = nav?.querySelector('[data-ezv3-more]');
    const moreMenu = nav?.querySelector('[data-ezv3-more-menu]');
    if (!nav || !more || !moreMenu) return;

    const entries = [...nav.querySelectorAll(':scope > [data-ezv3-nav-entry]')];
    if (!entries.length) return;

    let resizeFrame;

    const restore = () => {
      entries.forEach((entry) => {
        entry.classList.remove('is-responsive-hidden');
        entry.removeAttribute('aria-hidden');
      });
      moreMenu.innerHTML = '';
      more.hidden = true;
      more.removeAttribute('open');
    };

    const makeOverflowLink = (entry) => {
      const link = document.createElement('a');
      const title = entry.dataset.navTitle || entry.textContent.trim();
      const url = entry.dataset.navUrl || entry.getAttribute('href') || '#';
      link.href = url;
      link.textContent = title;
      return link;
    };

    const fit = () => {
      restore();

      if (window.innerWidth < 990) return;

      more.hidden = false;

      const available = nav.clientWidth;
      const moreWidth = more.getBoundingClientRect().width + 8;
      let used = moreWidth;
      const visible = [];

      entries.forEach((entry) => {
        const width = Math.ceil(entry.getBoundingClientRect().width);
        if (used + width <= available) {
          visible.push(entry);
          used += width;
        }
      });

      // Preserve the left-to-right priority. Move only trailing items.
      const visibleCount = visible.length;
      entries.forEach((entry, index) => {
        if (index >= visibleCount) {
          entry.classList.add('is-responsive-hidden');
          entry.setAttribute('aria-hidden', 'true');
          moreMenu.appendChild(makeOverflowLink(entry));
        }
      });

      more.hidden = moreMenu.children.length === 0;
      if (more.hidden) more.removeAttribute('open');
    };

    const scheduleFit = () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(fit);
    };

    scheduleFit();
    window.addEventListener('resize', scheduleFit, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(scheduleFit).observe(nav);
    }

    if (document.fonts?.ready) {
      document.fonts.ready.then(scheduleFit);
    }

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-ezv3-more]')) {
        more.removeAttribute('open');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseResponsiveHeader, { once: true });
  } else {
    initialiseResponsiveHeader();
  }

  document.addEventListener('shopify:section:load', initialiseResponsiveHeader);
})();
